import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./RootLumina";

createRoot(document.getElementById("root")!).render(<Root />);
